import React from 'react';
import { Link } from 'gatsby';
import { Container, Paper } from 'library';
import { formatDate } from 'utils/formatters';

import './PressReleaseList.scss';

const PressReleaseList = ({ pressReleases }) => {
  return (
    <Paper pad={{ top: 3, bottom: 6.8 }}>
      <Container row justify="center">
        <Container grid="10">
          <h2>Press Releases</h2>
          {pressReleases.map((post, index) => {
            return (
              <div className="PressReleaseList" key={index}>
                <p className="PressReleaseDate">{formatDate(post.date)}</p>
                <Link to={post.uri} title="View Press Release">
                  <h3>{post.title}</h3>
                </Link>
              </div>
            );
          })}
        </Container>
      </Container>
    </Paper>
  );
};

export default PressReleaseList;
